export { Template as EstatePlanningRecommendationQualificationSuccessStepTemplate } from './Template';
